module.exports = __webpack_public_path__ + "img/PigPushToy.55d432f2.webp";